export default __webpack_public_path__ + "static/media/logout-btn.5d7d3911.svg";